import TemplateView from "../../TemplateView"
import messageResource from "../../messageResource"
import CustomerPanelDetails from "./CustomerPanelDetails"
import CommentsSection from './CommentsSection'
import {Description} from '../Description'

export default class CustomerPanelContent extends TemplateView {
    constructor({
        updateDescription = () => {},
        refreshScrollCb = () => {},
        scrollToElementCb = () => {}
    }) {
        super()

        this.callbacks = {
            updateDescription,
            refreshScrollCb,
            scrollToElementCb,
        }
    }

    templateHtml() {
        return "<div class='tab detailsTab'>" +
               "  <div class='details'/>" +
               "  <div class='description'>" +
               "    <div class='title'><%=description%></div>" +
               "    <div class='descriptionArea'></div>" +
               "  </div>" +
               "  <div class='commentsSectionPlaceholder'></div>" +
               "</div>"
    }

    shouldUpdateOnInit() {
        return false
    }

    messageKeys() {
        return {
            description: "panel.common.description"
        }
    }

    afterRender() {
        this.$details = this.$containerEl.find(".details")
        this.details = new CustomerPanelDetails(this.$details).init()

        this.$description = this.$containerEl.find(".descriptionArea")
        this.description = new Description({
            onChange: this.callbacks.updateDescription,
        }).init(this.$description)
        this.description.setState({
            placeholder: messageResource.getMessage('customer.edit_panel.description.empty')
        })

        new CommentsSection({
            refreshScrollCb: this.callbacks.refreshScrollCb,
            scrollToElementCb: this.callbacks.scrollToElementCb,
        }).init(this.find('.commentsSectionPlaceholder'))
    }

    updateState({
        readOnly,
        active,
        spentTimeValues,
        description
    }) {
        this.details.setSelectorsDisabled(readOnly)
        this.details.setState({
            active,
            readOnly,
            spentTimeValues,
        })

        this.description.setState({
            text: description,
            editable: !readOnly,
            placeholder: readOnly ? messageResource.getMessage('panel.common.description.no_description')
                : messageResource.getMessage('customer.edit_panel.description.empty')
        });
        this.callbacks.refreshScrollCb()
    }

    updateLastAudit(lastUpdateAudit) {
        this.details.setLastAudit(lastUpdateAudit)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/customer/CustomerPanelContent.js